import { Close } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";
import Text from "@/components/ui/text";
import React from "react";

interface Props {
  labels: { message: string; button: string };
  onClose: () => void;
  onReconnect: () => void;
}

const ReconnectionBanner: React.FC<Props> = ({
  labels,
  onClose,
  onReconnect
}) => {
  return (
    <div className="h-9 flex w-full bg-surface-reconnection-banner items-center justify-center gap-2 transition-all duration-300">
      <Text>{labels.message}</Text>
      <Button variant="tertiary" onClick={onReconnect}>
        {labels.button}
      </Button>
      <IconButton size="sm" variant="iconNoBg" onClick={onClose}>
        <Close />
      </IconButton>
    </div>
  );
};

export default ReconnectionBanner;
